import {
  IonAccordion,
  IonAccordionGroup,
  IonItem,
  IonLabel
} from '@ionic/react';
import React from 'react';

const faqs = [
  {
    question: 'What is MyGolfProfile and how does it work?',
    answer: 'MyGolfProfile is a comprehensive golf app that helps you track scores, find courses, connect with other golfers, analyze your statistics, and participate in competitions. Simply sign up, input your golf data, and start improving your game!',
  },
  {
    question: 'How do I track my golf scores?',
    answer: 'After logging in, you can easily input your scores for each round. The app will automatically calculate your handicap and provide insights into your performance over time.',
  },
  {
    question: 'Can I use MyGolfProfile to find new golf courses?',
    answer: 'Yes! Our course finder feature allows you to discover new courses in your area or any location you\'re interested in. You can view course details, read reviews, and even book tee times through the app.',
  },
  {
    question: 'How does the social feature work?',
    answer: 'MyGolfProfile allows you to connect with other golfers, share your achievements, and even organize games together. You can follow friends, join groups, and participate in community discussions.',
  },
  {
    question: 'What kind of statistics does MyGolfProfile provide?',
    answer: 'MyGolfProfile offers a wide range of statistics including your handicap, average scores, fairways hit, greens in regulation, putts per round, and much more. These insights help you identify areas for improvement in your game.',
  },
  {
    question: 'How can I participate in competitions through MyGolfProfile?',
    answer: 'MyGolfProfile regularly hosts virtual tournaments and competitions. You can join these events, compete with golfers worldwide, and even win prizes. Check the \'Competitions\' tab in the app for current and upcoming events.',
  },
];

const FAQ: React.FC = () => {
  return (
    <section className="faq-section">
      <h2 className="text-center text-4xl font-medium tracking-tight text-neutral-800 dark:text-neutral-200 md:text-5xl">
        Any questions?
      </h2>
      <p className="mx-auto mt-4 max-w-lg text-center text-base text-neutral-600 dark:text-neutral-400">
        We're here to help you with any questions you may have. If you don't find what you need, please contact us at
        {' '}
        <a href="mailto:support@MyGolfProfile.com" className="text-primary underline">
          support@mgp.com
        </a>
      </p>

      <div className="mx-auto mt-10 w-full max-w-3xl">
        <IonAccordionGroup>
          {faqs.map((faq, index) => (
            <IonAccordion key={index} value={`item-${index}`}>
              <IonItem slot="header" className="ion-no-padding">
                <IonLabel>{faq.question}</IonLabel>
              </IonItem>

              <div slot="content" className="ion-padding">
                <p>{faq.answer}</p>
              </div>
            </IonAccordion>
          ))}
        </IonAccordionGroup>
      </div>
    </section>
  );
};

export default FAQ;
